/** Shared model types for menu navigation. Extracted to break the
 * HeaderDataService <-> header.component circular dependency. */

export class MenuItem {
    public readonly name: string;
    public readonly link?: string | string[] = null;
    public readonly style_class?: string;
    public readonly angular_page?: boolean = false;
    public readonly func?: any;

    constructor(init?: MenuItem) {
        Object.assign(this, init);
    }
}

export interface IMenu {
    name: string;
    items: MenuItem[];
    class: string;
}

export type Menu = Partial<IMenu>;
